<template>
  <el-dialog
    title=""
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <div style="min-height: 220px">
      <el-card class="box-card" shadow="hover" style="margin-bottom: 20px">
        <div slot="header" class="clearfix">
          <span>留言内容：</span>
        </div>
        <div class="text item" style="padding-left: 40px">
          {{ question }}
        </div>
      </el-card>
      <el-card class="box-card" shadow="hover" style="margin-bottom: 20px">
        <div slot="header" class="clearfix">
          <span>图片：</span>
        </div>
        <div class="text item" style="padding-left: 40px">
          <div class="img-list">
            <div
              v-for="(item, index) in imgList"
              :key="index"
              class="img-item"
              @click="openPreview(index)"
            >
              <img :src="getUrl(item)" :alt="getName(item)" class="img-thumb" />
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>回复：</span>
        </div>
        <div class="text item" style="padding-left: 40px">
          {{ answer }}
        </div>
      </el-card>
    </div>
  </el-dialog>
</template>
<script>
import { getLeaveMessageDetail } from "@/api/moudles/user";
export default {
  data() {
    return {
      dialogVisible: false,
      question: "",
      answer: "",
      dialogWidth: "50%",
      imgList: [],
    };
  },
  mounted() {
    console.log(this.$phoneSize());
    if (this.$phoneSize()) {
      this.dialogWidth = "95%";
    } else {
      this.dialogWidth = "50%";
    }
  },
  methods: {
    open(row) {
      console.log(row);
      const { id } = row;
      this.getDetail(id);
      this.dialogVisible = true;
    },
    openPreview() {},
    getUrl(item) {
      return typeof item === "string" ? item : item.fileUrl;
    },
    getName(item) {
      return typeof item === "string" ? "" : item.fileName || "";
    },
    async getDetail(id) {
      await getLeaveMessageDetail({
        data: {
          id,
        },
        success: (res) => {
          if (res.data) {
            this.question = res.data.question;
            this.answer = res.data.content;
            this.imgList = res.data.questionAttachments;
          } else {
            this.question = "";
            this.answer = "";
            this.imgList = [];
          }
        },
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.textarea = "";
    },
  },
};
</script>

<style scoped>
.img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.img-item {
  width: 120px; /* 统一宽度，按需改 */
  height: 120px; /* 统一高度，按需改 */
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #eee;
  transition: transform 0.2s, box-shadow 0.2s;
}

.img-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.img-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 等比裁剪，不变形 */
  display: block;
}
</style>
